import { useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from '../store'
import { selectIsAuthenticated } from '../store/slices/userSlice'
import { useGetSessionQuery } from '../store/api/auth'
import { useAuthInit } from '../hooks/useAuthInit'

/**
 * AuthGuard — protected route wrapper.
 * Checks /api/auth/session on mount. If 200 → hydrates store, renders children.
 * If 401 → redirects to /login.
 */
export function AuthGuard() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const location = useLocation()
  const { initSession } = useAuthInit()

  const { data, error, isLoading } = useGetSessionQuery(undefined, {
    skip: isAuthenticated,
  })

  useEffect(() => {
    if (data) {
      initSession(data, 'session')
    }
  }, [data, initSession])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen-dynamic" style={{ backgroundColor: 'var(--bg-base)' }}>
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#F7941D] border-t-transparent" />
      </div>
    )
  }

  if (!isAuthenticated && error) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!isAuthenticated && !data) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
